<template>
  <v-container class="sitemap py-10">
    <h1 class="text-h4 font-weight-bold mb-6">網站導覽</h1>

    <section class="mb-8">
      <h2 class="text-h5 font-weight-bold mb-4">網站主要架構</h2>
      <ul>
        <li>
          <router-link to="/">首頁／資格查詢與預約</router-link>
        </li>
        <li>
          <router-link to="/privacy">服務條款與隱私權保護規範</router-link>
        </li>
        <li>
          <router-link to="/personal">個人資料確認</router-link>
        </li>
        <li>
          <router-link to="/itemCheck">健檢項目資格確認</router-link>
        </li>
        <li>
          <router-link to="/itemConfirm">健檢項目確認</router-link>
        </li>
        <li>
          <router-link to="/section">預約場次選擇</router-link>
        </li>
        <li>
          <router-link to="/confirm">預約資訊確認</router-link>
        </li>
        <li>
          <router-link to="/survey">問卷填寫</router-link>
        </li>
        <li>
          <router-link to="/quick">快速健檢預約</router-link>
        </li>
        <li>
          <router-link to="/station">到站檢測作業</router-link>
        </li>
      </ul>
    </section>

    <section class="mb-8">
      <h2 class="text-h5 font-weight-bold mb-4">鍵盤操作說明</h2>
      <ul>
        <li>使用 Tab 鍵可依序移動至頁面中的連結、表單欄位與按鈕。</li>
        <li>使用 Shift + Tab 鍵可反向移動鍵盤焦點。</li>
        <li>焦點移至連結或按鈕時，可按 Enter 鍵執行。</li>
        <li>每個前台頁面頂端皆提供「跳到主要內容」連結，可直接移至中央內容區。</li>
      </ul>
    </section>
  </v-container>
</template>

<script>
export default {
  name: "Sitemap",
};
</script>

<style lang="scss" scoped>
.sitemap {
  max-width: 900px;
}
.sitemap li {
  margin-bottom: 0.75rem;
  line-height: 1.7;
}
</style>
